import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  // Only attach auth headers for requests to our API
  const isApiRequest = req.url.startsWith(environment.apiUrl) || req.url.startsWith('/v1');
  if (!isApiRequest) {
    return next(req);
  }

  const token = getTokenFromCookie();
  if (!token) {
    return next(req);
  }

  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });

  return next(authReq).pipe(
    catchError((error) => {
      if (error.status === 401) {
        document.cookie = 'authToken=; Max-Age=0; path=/';
        router.navigate(['/login']);
      }
      return throwError(() => error);
    })
  );
};

function getTokenFromCookie(): string | null {
  const name = 'authToken=';
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    cookie = cookie.trim();
    if (cookie.startsWith(name)) {
      return cookie.substring(name.length);
    }
  }
  return null;
}
